<template>
  <b-card
    no-body
    class="card-revenue-budget"
  >
    <b-card-header>
      <div>
        <b-card-title>  Outlets Summary </b-card-title>
      </div>
    </b-card-header>
    <b-card-body>
      <b-row class="mx-0">
        <b-col
            md="12"
            class="revenue-report-wrapper"
        >

          <table class="table table-striped">
            <tr>
              <th>Total Live </th>
              <td><a style="text-decoration: underline; font-weight: bolder;" href="/apps/outlets?status=ACTIVE">{{ merchantsSummary.totalMerchants | number('0,0')  }}</a></td>
            </tr>
            <tr>
              <th>Active (Issued Points)</th>
              <td><a style="text-decoration: underline; font-weight: bolder;" href="/apps/outlets?status=ISSUED_POINTS">{{ merchantsSummary.activeMerchants | number('0,0')  }}</a></td>
            </tr>
            <tr>
              <th>Inactive (Not issued points in the last 30 days)</th>
              <td><a style="text-decoration: underline; font-weight: bolder;" href="/apps/outlets?status=INACTIVE">{{ merchantsSummary.inactiveMerchants | number('0,0')  }}</a></td>
            </tr>
            <tr>
              <th>Not Issued Points</th>
              <td><a style="text-decoration: underline; font-weight: bolder;" href="/apps/outlets?status=NOT_ISSUED_POINTS">{{ merchantsSummary.dormantMerchants | number('0,0')  }}</a></td>
            </tr>
          </table>

        </b-col>
      </b-row>
    </b-card-body>

    <b-modal id="filter-by-date-merchants-summary" title="Filter By Date" @cancel="true" @ok="getMerchantsSummaryData"   centered>
      <form action="#" class="form-horizontal"  method="post">
        <input type="hidden" name="_token" />
        <div class="form-body">
          <div class="row" >
            <div class="col-md-6">
              <div class="form-group ">
                <label class="control-label ">Start Date:</label> <br/>
                <div >
                  <date-picker  :lang="lang" v-model="startDate" valueType="format" :first-day-of-week="1"></date-picker>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group ">
                <label class="control-label ">End Date:</label> <br/>
                <div >
                  <date-picker  :lang="lang" v-model="endDate" valueType="format" :first-day-of-week="1"></date-picker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import {mapActions} from "vuex";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BCard,
    BButton,
    BRow,
    BCol,
    DatePicker
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      startDate:'2023-07-01',
      endDate:new Date().toISOString().split('T')[0],
      merchantsSummary:{
        activeMerchants:0,
        totalMerchants:0,
        inactiveMerchants:0,
        dormantMerchants:0
      },
    }
  },
  mounted (){
    this.getMerchantsSummaryData();
  },
  methods: {
    ...mapActions(["getMerchantsSummary"]),

    getMerchantsSummaryData(){
      let self = this;
      this.getMerchantsSummary({startDate: this.startDate, endDate : this.endDate})
          .then(function (merchantsSummary) {

            self.merchantsSummary = merchantsSummary;

          })
          .catch(function (error) {


            if( typeof error.response.status != "undefined"){
              if(error.response.status == 401){
                location.replace("/login");
              }

            }
          })
    },
  }
  }
</script>
